import { makeStyles, Paper } from "@material-ui/core";
import { Link } from "../shared/Texts";
import { Grid, Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        marginTop: theme.spacing(7),
        maxWidth: 700,
        maxHeight: 500
    },
}));

const NotAuthorized = () => {
    const classes = useStyles();
    return (
        <Paper className={classes.paper}>
            <Grid container alignContent="center" xs={12}>
                    <Typography
                        sx={{
                            fontWeight: "bolder",
                            textAlign: "left",
                            marginRight: 0.5,
                        }}
			        >
				        Accès non autorisé :
			        </Typography>
                    <Grid item>
                            vous n'avez pas les droits pour accéder à cette page.
                    </Grid>
                    <Grid container spacing={0.5} alignContent="center" >
                        <Grid item>
                            Vous pouvez contacter
                        </Grid>
                        <Grid item >
                            <Link text="l'assistance SARA" href={"https://www.sante-ara.fr/contact"}/>
                        </Grid> 
                        <Grid item>
                            pour toute information complémentaire.
                        </Grid>  
                    </Grid>  
            </Grid>
        </Paper>
    )
}

export default NotAuthorized